import React from 'react';
import classnames from 'classnames';

export interface CardBodyProps extends React.HTMLAttributes<HTMLElement> {
  element?: keyof JSX.IntrinsicElements;
  component?: React.ElementType;
  className?: string;
  fullWidth?: boolean;
}

const CardBody: React.FunctionComponent<CardBodyProps> = ({
  element = 'div',
  component,
  className,
  fullWidth = false,
  ...props
}) => {
  const CardBodyElement = component || element;

  return (
    <CardBodyElement
      className={classnames('card__body', fullWidth && 'mw-none', className)}
      {...props}
    />
  );
};

export default CardBody;
